module.exports = __webpack_public_path__ + "img/func_4_3.bb759a59.svg";